import iconStarSelected from "assets/icons/star-selected.svg";
import iconStarUnselected from "assets/icons/star-unselected.svg";

type TOnChangeReturn = {
    target: {
        value: {
            lat: number;
            lng: number;
        };
    };
};

const StarsInput = (props: { value: any; onChange: (value: any) => TOnChangeReturn }) => {
    const { value, onChange = () => {} } = props;
    return (
        <div className="flex flex-row gap-2 w-full items-cetner justify-center">
            {new Array(5).fill(0).map((_, i) => {
                return (
                    <img
                        alt="Star"
                        src={i < value ? iconStarSelected : iconStarUnselected}
                        onClick={() => onChange({ target: { value: i + 1 } })}
                        className="w-10 h-10 cursor-pointer"
                    />
                );
            })}
        </div>
    );
};

export default StarsInput;
